"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _linkHelper2 = _interopRequireDefault(require("../../../../../shared/helpers/linkHelper"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("../../../../../shared/components/MarkdownRenderers/MarkdownLinkRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ClickableImageTemplate = function ClickableImageTemplateComponent(_ref) {
  var image = _ref.image,
      linkTo = _ref.linkTo;

  var _linkHelper = (0, _linkHelper2["default"])(linkTo.url),
      cleanHref = _linkHelper.cleanHref;

  return /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], {
    className: "responsive-hero__clickable-banner",
    href: linkTo.url,
    external: linkTo.target === '_blank'
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: image.url,
    alt: "",
    className: "responsive-hero__image"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "responsive-hero__link-text"
  }, "Go to ".concat(cleanHref)));
};

ClickableImageTemplate.propTypes = {
  image: _propTypes["default"].shape({}).isRequired,
  linkTo: _propTypes["default"].shape({}).isRequired
};
var _default = ClickableImageTemplate;
exports["default"] = _default;